import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTimesCircle, faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import { httpClient } from '../utils/httpClient';
import { Link } from 'react-router-dom'

import './CompareProduct.css'

const CompareProduct = () => {
  const [loading, setLoading] = useState(true);
  const [product, setProduct] = useState([]);
  const [products, setProducts] = useState([]);
  const [emptyProduct, setEmptyProduct] = useState([]);
  const [metrics, setMetrics] = useState([
    {
      name: 'Tipe',
      active: true
    },
    {
      name: 'Kondisi',
      active: true,
      parameter: 'condition',
      bike_parameter: 'condition'
    },
    {
      name: 'Tahun',
      active: true,
      parameter: 'year',
      bike_parameter: 'year'
    },
    {
      name: 'Harga',
      active: true,
      parameter: 'price',
      bike_parameter: 'price'
    },
    {
      name: 'Cicilan',
      active: true,
      parameter: 'installment',
      bike_parameter: 'installment'
    },
    {
      name: 'Kilometer',
      active: true,
      parameter: 'mileage'
    },
    {
      name: 'Transmisi',
      active: true,
      parameter: 'CarType',
      parameter2: 'transmission',
      bike_parameter: 'BikeType',
      bike_parameter2: 'transmission'
    },
    {
      name: 'Kapasitas Mesin',
      active: true,
      parameter: 'CarType',
      parameter2: 'machine_capacity',
      bike_parameter: 'BikeType',
      bike_parameter2: 'capacity'
    },
    {
      name: 'Kapasitas Penumpang',
      active: true,
      parameter: 'CarType',
      parameter2: 'seat',
      bike_parameter: 'null'
    },
    {
      name: 'Dimensi',
      active: true,
      parameter: 'CarType',
      parameter2: 'dimension',
      bike_parameter: 'BikeType',
      bike_parameter2: 'dimension'
    },
    {
      name: 'Lokasi',
      active: true,
      parameter: 'City',
      parameter2: 'name',
      bike_parameter: 'City',
      bike_parameter2: 'name'
    }
  ])

  const splitThousand = (number) => {
    if (!number && number !== 0) return "";
    return `${number}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  const addProductJS = () => {
    return (
      <div className="col-md-3">
        <div>
          <div className="comparasion-car-select">
            <Link to={`/gallery/mobil`}>
              <div className="comparasion-car-input">
                <div>
                  <div className="text--center">
                    <span className="text--color-gold"><FontAwesomeIcon icon={faPlusCircle} /></span>
                  </div>
                  <div>
                    <p className="mb--0">Tambah Kendaraan</p>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    )
  }

  const fetchProduct = async(isCar, id) => {
    const data = product;
    const res = await httpClient.get(`/${isCar == "true" ? 'car' : 'bike'}/${id}`)
    const payloadCalc = { dp: 30, tenor: isCar == "true" ? 60 : 30 };
    const result = await httpClient.post(`/${isCar == "true" ? 'car' : 'bike'}/${id}/calculator`, payloadCalc);
    res.data.installment = result.data.result
    data.push(res.data)
    setProduct(data)
    setLoading(false)
  }

  const setAllProduct = async() => {
    setProducts(product);
    const empty = [];
    for(let i = 0; i < 3 - product.length; i ++) {
      empty.push(addProductJS())
    }
    setEmptyProduct(empty);
  }

  const loopProduct = async() => {
    if (localStorage.getItem("comparison1") != null) {
      await fetchProduct(localStorage.getItem("comparison1").split(",")[0], localStorage.getItem("comparison1").split(",")[1])
    }

    if (localStorage.getItem("comparison2") != null) {
      await fetchProduct(localStorage.getItem("comparison2").split(",")[0], localStorage.getItem("comparison2").split(",")[1])
    }

    if (localStorage.getItem("comparison3") != null) {
      await fetchProduct(localStorage.getItem("comparison3").split(",")[0], localStorage.getItem("comparison3").split(",")[1]) 
    }
    setAllProduct();
  }

  const removeComparison = (index) => {
    localStorage.removeItem("comparison" + (index + 1))
    window.location.reload();
  }

  useEffect(() => {
    loopProduct();
  }, [])

  const setActiveMetric = (index) => {
    const currState = [...metrics];
    currState[index].active = !currState[index].active;
    setMetrics(currState)
  }

  const setData = (product, metric) => {
    if (product.CarType) {
      if (metric.name == "Tipe") {
        return `${product.CarType.specification} ${product.CarType.type} ${product.CarType.transmission == 'Manual' ? "MT" : "AT"} ${product.class ? product.class : ""}`;
      }
      if (metric.name == "Harga" || metric.name == "Cicilan") {
        return "Rp. " + splitThousand(metric.parameter2 ? product[`${metric.parameter}`][`${metric.parameter2}`] : product[`${metric.parameter}`])
      }
      if (metric.name == "Kilometer") {
        return splitThousand(metric.parameter2 ? product[`${metric.parameter}`][`${metric.parameter2}`] : product[`${metric.parameter}`])
      }
      return metric.parameter2 ? product[`${metric.parameter}`][`${metric.parameter2}`] : product[`${metric.parameter}`];
    } else {
      if (metric.name == "Tipe") {
        return `${product.BikeType.type}`
      }
      if (metric.name == "Harga" || metric.name == "Cicilan") {
        return "Rp. " + splitThousand(metric.bike_parameter2 ? product[`${metric.bike_parameter}`][`${metric.bike_parameter2}`] : product[`${metric.bike_parameter}`]);
      }
      if (metric.name == "Kilometer") {
        return splitThousand(metric.bike_parameter2 ? product[`${metric.bike_parameter}`][`${metric.bike_parameter2}`] : product[`${metric.bike_parameter}`]);
      }
      return metric.bike_parameter2 ? product[`${metric.bike_parameter}`][`${metric.bike_parameter2}`] : product[`${metric.bike_parameter}`];
    }
  }

  return (
    <div className="comparasion-wrapper">
      <div className="section-wrapper section-blue">
        <div className="container">
          <div className="row">
            <div className="col">
              <h1 className="title-big">
                Perbandingan Mobil
              </h1>
              <div className="comparasion-metric-wrapper">
                <div className="metric-title metric-item">Metrik:</div>
                { metrics.map((metric, index) => (
                  <div
                    onClick={() => setActiveMetric(index)}
                    className={`metric-button metric-item ${metric.active ? 'active' : null}`}
                    key={`${metric.name}-${index}`}>
                      {metric.name}
                  </div>
                )) }
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section-wrapper">
        <div className="container">
          <div className="row justify-content-end mb--2">
            { products && products.map((product, index) => (
              <div className="col-md-3">
                <div className="">
                  <div className="comparasion-car-select mb--1">
                    <img src={product.images[0]} alt=""/>
                  </div>
                  <div className="fx justify-content-between align-items-center">
                    <div>
                      <p className="mb--0">{product.CarType ? product.CarType.brand_name : product.BikeType.brand_name}</p>
                    </div>
                    <div className="comparasion-car-remove">
                      <span onClick={() => removeComparison(index)}><FontAwesomeIcon icon={faTimesCircle} /></span>
                    </div>
                  </div>
                </div>
              </div>
            )) }
            {emptyProduct}
          </div>

          {
            metrics && metrics.map((metric, index) => (
              <div>
              {
                metric.active && (
                  <div className="row commparasion-table">
                    <div className="col-md-3">
                      <div className="comparasion-table-column">
                        <p><strong>{metric.name}</strong></p>
                      </div>
                    </div>
                    <div className="col-md-9">
                      <div className="row row-metric-detail">
                        { products && products.map((product, index) => (
                          <div className="col-md-4">
                            <div className="comparasion-table-column">
                              <p className="text--color-gold"><strong>{setData(product, metric)}</strong></p>
                            </div>
                          </div>
                          ))
                        }
                      </div>
                    </div>
                  </div>
                )
              }
              </div>
            ))
          }

        </div>
      </div>
    </div>
  )
}

export default CompareProduct